import {provideRouter} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import {provideMsalProviders} from './security/msal.provider';
import {routes} from '../app.routes';
import {provideEffects} from '@ngrx/effects';
import {provideStore} from '@ngrx/store';
import {provideStoreDevtools} from '@ngrx/store-devtools';
import {isDevMode} from '@angular/core';
import {portfolioSimulatorFeature} from '@app/features/portfolio-simulator/store/portfolio-simulator.reducer';
import {PortfolioSimulatorEffects} from '@app/features/portfolio-simulator/store/portfolio-simulator.effects';

registerLocaleData(localeFr);
registerLocaleData(localeEn);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideMsalProviders(),
    provideStore({
      [portfolioSimulatorFeature.name]: portfolioSimulatorFeature.reducer,
    }),
    provideEffects(PortfolioSimulatorEffects),
    provideStoreDevtools({maxAge: 25, logOnly: !isDevMode()}),
  ],
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
